import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  services = {
    "dinopol": {
      title: "Zone de Police 5321 - Dinopol",
      content: `
        <p><strong>Zone de Police Bernissart-Péruwelz</strong></p>
        <p>La zone de police locale 5321 "Dinopol" couvre les communes de Bernissart et Péruwelz.</p>
        <hr>
        <p><strong>Contact général :</strong></p>
        <ul>
          <li>Péruwelz : 069/66.98.20</li>
          <li>Bernissart : 069/59.02.10</li>
        </ul>
      `
    },
    "sipp": {
      title: "Service Interne de Protection et de Prévention au Travail",
      content: `
        <p>Le SIPP est chargé de la prévention des risques professionnels et de la protection de la santé et de la sécurité des travailleurs au sein de la zone de police.</p>
      `
    },
    "chef-corps": {
      title: "Chef de Corps",
      content: `
        <p><strong>1er Commissaire Divisionnaire de Police O. MOULIN</strong></p>
        <hr>
        <p>Le Chef de Corps est responsable de la direction générale de la zone de police. Il assure le commandement opérationnel et administratif de l'ensemble des services.</p>
      `
    },
    "secretariat-zonal": {
      title: "Secrétariat Zonal",
      content: `
        <p>Le secrétariat zonal assure le support administratif pour les organes de gestion de la zone de police.</p>
      `
    },
    "conseils": {
      title: "Organes de Gouvernance",
      content: `
        <ul>
          <li><strong>Conseil de Police :</strong> Organe délibérant de la zone</li>
          <li><strong>Collège de Police :</strong> Organe exécutif de la zone</li>
          <li><strong>Comité de Concertation de Base :</strong> Concertation syndicale</li>
          <li><strong>Conseil Zonal de Sécurité :</strong> Politique de sécurité locale</li>
        </ul>
      `
    },
    "cabinet": {
      title: "Cabinet du Chef de Corps",
      content: `
        <p>Le cabinet comprend plusieurs services de support :</p>
        <ul>
          <li><strong>Stratégie :</strong> Planification et développement</li>
          <li><strong>Communication :</strong> Relations publiques et médias</li>
          <li><strong>Contrôle interne :</strong> Audit et conformité</li>
          <li><strong>ICT :</strong> Informatique et télécommunications</li>
          <li><strong>DPO :</strong> Protection des données (RGPD)</li>
          <li><strong>Secrétariat :</strong> Support administratif</li>
        </ul>
      `
    },
    "direction-operationnelle": {
      title: "Direction Opérationnelle",
      content: `
        <p>La direction opérationnelle coordonne l'ensemble des services de police de terrain : intervention, proximité, recherche et enquêtes.</p>
      `
    },
    "direction-ressources": {
      title: "Direction des Ressources",
      content: `
        <p>La direction des ressources gère les moyens humains, logistiques et financiers de la zone de police.</p>
      `
    },
    "secretariat-ops": {
      title: "Secrétariat Opérationnel",
      content: `
        <p>Support administratif pour la direction opérationnelle.</p>
      `
    },
    "gpi48": {
      title: "GPI 48",
      content: `
        <p>Maîtrise de la violence avec et sans arme à feu.</p>
      `
    },
    "brigade-canine": {
      title: "Brigade Canine",
      content: `
        <p>Un maître chien de patrouille intervient en appui des équipes de première ligne; il réalise aussi de nombreuses patrouilles pédestres et proactives dans les secteurs nécessitant une attention accrue.</p>
      `
    },
    "mobilite": {
      title: "Mobilité",
      content: `
        <p>Service chargé entre autre de rendre des avis sur des aménagements en matière de sécurité routière.</p>
      `
    },
    "accueil": {
      title: "Accueil - Plaintes - CTR",
      content: `
        <p>Service d'accueil du public pour :</p>
        <ul>
          <li>Renseignements généraux</li>
          <li>Dépôt de plaintes</li>
        </ul>
        <hr>
        <p><strong>Contact :</strong></p>
        <ul>
          <li>Péruwelz : <a href="tel:069669820">069/66.98.20</a></li>
          <li>Bernissart : <a href="tel:069590210">069/59.02.10</a></li>
        </ul>
      `
    },
    "intervention": {
      title: "Service Intervention",
      content: `
        <p>Le service d'intervention assure les patrouilles et répond aux appels urgents 24h/24, 7j/7.</p>
        <p>Le service circulation gère la sécurité routière et les accidents de la route.</p>
      `
    },
    "proximite": {
      title: "Service de Proximité",
      content: `
        <p>Les agents de quartier assurent une présence de proximité et sont les interlocuteurs privilégiés des citoyens pour les problèmes locaux.</p>
      `
    },
    "bureau-judiciaire": {
      title: "Bureau Judiciaire",
      content: `
        <p>Suivi et gestion des procès-verbaux, contacts et coordination avec les autorités judiciaires.</p>
      `
    },
    "assistance-victimes": {
      title: "Assistance Policière aux Victimes",
      content: `
        <p>Service d'aide et d'accompagnement des victimes d'infractions. Orientation vers les services d'aide spécialisés.</p>
      `
    },
    "enquete-recherche": {
      title: "Enquête et Recherche",
      content: `
        <p>Service d'enquête judiciaire de la zone de police, composé de plusieurs sections spécialisées.</p>
      `
    },
    "criminalite-personnes": {
      title: "Criminalité contre les personnes",
      content: `
        <p>Enquêtes relatives aux atteintes aux personnes : violences, menaces, harcèlement, etc.</p>
      `
    },
    "moeurs-jeunesse": {
      title: "Mœurs - Jeunesse - Famille et VII",
      content: `
        <p>Section spécialisée dans :</p>
        <ul>
          <li>Infractions à caractère sexuel</li>
          <li>Protection de la jeunesse</li>
          <li>Violences intrafamiliales (VII)</li>
        </ul>
      `
    },
    "criminalite-biens": {
      title: "Criminalité contre les biens",
      content: `
        <p>Enquêtes relatives aux atteintes aux biens : cambriolages, dégradations, escroqueries, etc.</p>
      `
    },
    "vols-stupo": {
      title: "Vols - Stupéfiants - Ecofin",
      content: `
        <p>Section chargée des enquêtes relatives aux :</p>
        <ul>
          <li>Vols qualifiés</li>
          <li>Trafic de stupéfiants</li>
          <li>Criminalité économique et financière</li>
        </ul>
      `
    },
    "environnement": {
      title: "Environnement - Fraude sociale",
      content: `
        <p>Section spécialisée dans :</p>
        <ul>
          <li>Infractions environnementales</li>
          <li>Fraude sociale et travail au noir</li>
        </ul>
      `
    },
    "armes-pacos": {
      title: "Armes - PACOS",
      content: `
        <p>Section chargée de :</p>
        <ul>
          <li>Contrôle de la détention d'armes</li>
          <li>PACOS (Traitement des pièces à conviction)</li>
        </ul>
      `
    },
    "ressources-humaines": {
      title: "Ressources Humaines",
      content: `
        <p>Gestion du personnel de la zone de police :</p>
        <ul>
          <li>Recrutement et mobilité</li>
          <li>Formation continue</li>
          <li>Gestion des carrières</li>
          <li>Administration du personnel</li>
        </ul>
      `
    },
    "ressources-logistiques": {
      title: "Ressources Logistiques",
      content: `
        <p>Gestion des moyens matériels :</p>
        <ul>
          <li>Parc automobile</li>
          <li>Équipements et matériel</li>
          <li>Bâtiments et infrastructures</li>
          <li>Approvisionnement</li>
        </ul>
      `
    },
    "ressources-financieres": {
      title: "Ressources Financières",
      content: `
        <p>Gestion budgétaire et comptable de la zone de police :</p>
        <ul>
          <li>Préparation et suivi du budget</li>
          <li>Comptabilité</li>
          <li>Marchés publics</li>
        </ul>
      `
    },
    "comptable-special": {
      title: "Comptable Spécial",
      content: `
        <p>Le comptable spécial est désigné par le Conseil de Police. Il est chargé de l'exécution des paiements et de la gestion de la trésorerie de la zone.</p>
      `
    }
  }

  connect() {
    this.modalElement = document.getElementById("organigrammeModal")
    this.modal = new bootstrap.Modal(this.modalElement)
    this.modalTitle = document.getElementById("organigrammeModalLabel")
    this.modalBody = this.modalElement.querySelector(".modal-body")
  }

  showModal(event) {
    const serviceId = event.params.service
    const service = this.services[serviceId]

    if (service) {
      this.modalTitle.textContent = service.title
      this.modalBody.innerHTML = service.content
      this.modal.show()
    }
  }
}
